export default "__VITE_ASSET__CNFnW1SZ__"